import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { Direktvermarkter } from "../../../utils/backend-types";
import type { DirektvermarktungContractOverviewResponse } from "../Direktvermarktung.types";

function getDirektvermarkterColumn(
  direktvermarkters: Array<Direktvermarkter>
): MRT_ColumnDef<DirektvermarktungContractOverviewResponse> {
  return {
    id: "direktvermarkter",
    header: "Direktvermarkter",
    accessorFn: (row) => {
      return direktvermarkters.find(
        (d) => Number(d.id) === Number(row.direktvermarkter_id)
      )?.name;
    },
    filterVariant: "multi-select"
  };
}

export { getDirektvermarkterColumn };
